module.exports = __webpack_public_path__ + "img/address.a08022ea.png";